import Vue from 'vue';

export default {
    isPrefetchRequired(to, from) {
        const forcePrefetch = Vue.$store.state.forcePrefetch;
        Vue.$store.commit('setForcePrefetch', false);

        return Vue.$store.state.user.isAuthenticated &&
            (
                forcePrefetch ||
                (
                    (
                        (!to.meta.parentRouteName && !from.meta.parentRouteName) ||
                        to.name !== from.name
                    ) &&
                    (!to.meta.parentRouteName || to.meta.parentRouteName !== from.name) &&
                    (!from.meta.parentRouteName || from.meta.parentRouteName !== to.name)
                )
            );
    },
};